import { render, staticRenderFns } from "./datatables_ikid_check_v2.vue?vue&type=template&id=5e59188f&"
import script from "./datatables_ikid_check_v2.vue?vue&type=script&lang=js&"
export * from "./datatables_ikid_check_v2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports